import React, { Component } from 'react';
import Odomtr from 'odometer';

export default class Odometer extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    const currencyMap = {
      'en-US': {
        prefix: '$',
        suffix: '',
        format: ',ddd'
      },
      'en-CA': {
        prefix: '$',
        suffix: '',
        format: ',ddd'
      },
      'fr-CA': {
        prefix: '',
        suffix: String.fromCharCode(160) + '$',
        format: ' ddd'
      },
      'pt-BR': {
        prefix: 'R$' + String.fromCharCode(160),
        suffix: '',
        format: '.ddd'
      }
    };
    this.localeSettings =
      currencyMap[this.props.locale] || currencyMap['en-US'];
  }

  componentDidMount() {
    const value = this.props.value;
    const format = this.localeSettings.format;
    this.odometer = new Odomtr({
      el: this.ref.current,
      value,
      format
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.odometer.update(this.props.value);
    }
  }

  render() {
    return (
      <div className="odometer__wrapper">
        <div className="odometer__prefix">{this.localeSettings.prefix}</div>
        <div ref={this.ref} className="odometer__value" />
        <div className="odometer__suffix">{this.localeSettings.suffix}</div>
      </div>
    );
  }
}
